import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UserDetailsStepOnePage.css";
import nextIcon from "../../assets/nextButtonIcon.png";
import appIcon from "../../assets/appIcon.svg";
import { useGlobalAlert } from "../../context/AlertContext";
import MobileTopBar from "../../components/MobileTopBar";
import MobileBottomBar from "../../components/MobileBottomBar";
import DesktopTopBar from "../../components/DesktopTopBar";
import DesktopBottomBar from "../../components/DesktopBottomBar";

const UserDetailsStepOnePage = ({ formData, setFormData }) => {
  const navigate = useNavigate();
  const { triggerAlert } = useGlobalAlert();

  const currentText =
    (formData.selectedBringsYouHere && formData.selectedBringsYouHere[0]) ||
    (formData.whatsBringsYou && formData.whatsBringsYou[0]) ||
    (formData.brings_you_here && formData.brings_you_here[0]) ||
    (formData.bringsYouHere && formData.bringsYouHere[0]) ||
    "";

  const handleChange = (e) => {
    const value = e.target.value;

    const updatedList = value.trim() !== "" ? [value] : [];

    setFormData((prev) => ({
      ...prev,
      selectedBringsYouHere: updatedList,
      whatsBringsYou: updatedList,
      brings_you_here: updatedList,
    }));
  };

  const isNextDisabled = !currentText.trim();

  const handleNext = () => {
    if (isNextDisabled) {
      triggerAlert("Please share what brings you here to continue", "error");
      return;
    }
    navigate("/user-details-step-two");
  };

  const handleSkip = () => {
    navigate("/user-details-step-two");
  };

  return (
    <div className="uds1-container">
      {/* LEFT PANEL - Hidden on Mobile */}
      <div className="uds1-left-panel uds1-desktop-only">
        <div className="uds1-bg-image" />
        <div className="uds1-bg-overlay"></div>
        <DesktopTopBar
          showBack={true}
          onBack={() => navigate("/completion-page")}
          backColor="#000"
          showProgress={false}
        />
      </div>

      {/* RIGHT PANEL */}
      <div className="uds1-right-panel">
        <MobileTopBar
          onBack={() => navigate("/completion-page")}
          backColor="#fff"
          logoColor="#fff"
          isProtectedRoute={false}
        />

        <div className="uds1-content-wrapper">
          <div className="uds1-title-container">
            <h1 className="uds1-title">WHAT BRINGS YOU HERE?</h1>
          </div>

          <div className="uds1-paragraphs">
            <p>
              Perhaps your pup could use more socialization, you'd like to save
              money on dog care, or you simply want to feel less pup pawrent
              guilt - we get it!
            </p>
            <p>
              Whatever your reason, we want to hear about your interest in
              dog-sharing! 🐾
            </p>
          </div>

          <textarea
            className="uds1-textarea"
            placeholder="Share what brings you here!"
            value={currentText}
            onChange={handleChange}
          />

          <DesktopBottomBar
            onNext={handleNext}
            isNextEnabled={!isNextDisabled}
            nextIconSrc={nextIcon}
            variant="green"
          />

          <MobileBottomBar
            onNext={handleNext}
            isNextEnabled={!isNextDisabled}
            nextIconSrc={nextIcon}
            showSkip={true}
            onSkip={handleSkip}
            variant="green"
          />
        </div>
      </div>
    </div>
  );
};

export default UserDetailsStepOnePage;
